export default "__VITE_ASSET__B7mJ9yZX__"